import { apiInstance } from "@/api/instance";

export default async function (counselId) {
  return apiInstance.get(`/counsel/${counselId}/comment`);
}
